export const MIN_NOTE_LENGTH = 1;
export const MAX_NOTE_LENGTH = 4000;

export const validateFormState = (note: string) => {
    if (note.trim().length < MIN_NOTE_LENGTH) {
        return "Write a note before adding";
    }

    if (note.length > MAX_NOTE_LENGTH) {
        return "Your note is too long";
    }

    return "";
};
